import { create } from 'zustand';
import type { PotStatus } from '../types/pot.types';

interface PotApprovalsUIState {
  searchText: string;
  collapsedStatuses: Set<PotStatus>;
}

interface PotApprovalsUIActions {
  setSearchText: (text: string) => void;
  clearSearch: () => void;
  toggleStatusGroup: (status: PotStatus) => void;
  reset: () => void;
}

export const usePotApprovalsUIStore = create<
  PotApprovalsUIState & PotApprovalsUIActions
>(set => ({
  searchText: '',
  collapsedStatuses: new Set(),
  setSearchText: (text: string) => set({ searchText: text }),
  clearSearch: () => set({ searchText: '' }),
  toggleStatusGroup: (status: PotStatus) =>
    set(state => {
      const next = new Set(state.collapsedStatuses);
      if (next.has(status)) {
        next.delete(status);
      } else {
        next.add(status);
      }
      return { collapsedStatuses: next };
    }),
  reset: () => set({ searchText: '', collapsedStatuses: new Set() }),
}));
